import * as React from 'react'
import useRouter from 'use-react-router'
import styled from 'styled-components'

import { Lang } from '../assets/i18n'

const LangSelectorList = styled.ul`
  list-style: none;
  display: flex;
  li {
    text-transform: uppercase;
    margin: 0 8px;
  }
`

export const LangSelector = () => {
  const { match, location, history } = useRouter<any>()
  const currentLang = match.params.locale || 'fi'
  const createHref = (lang: Lang) =>
    history.createHref({
      ...location,
      pathname: `${location.pathname.replace(
        '/' + currentLang + '/',
        '/' + lang + '/'
      )}`
    })

  const renderLink = (lang: Lang) => (
    <li data-qa={'selector'} data-qa-value={lang}>
      {lang === currentLang ? lang : <a href={createHref(lang)}>{lang}</a>}
    </li>
  )

  return (
    <LangSelectorList data-qa="languageSelector">
      {renderLink('fi')}
      {'|'}
      {renderLink('sv')}
      {'|'}
      {renderLink('en')}
    </LangSelectorList>
  )
}
